export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/pattern_design.98def8f.svg";